export default "__VITE_ASSET__Ca196P7v__"